import { ManagementCompany } from "../../types";
import Cif from "./Cells/Cif";
import Name from "./Cells/Name";
import Save from "./Cells/Save";

type Col = {
	id: string;
	Cell: (right: ManagementCompany) => JSX.Element | null;
	label: string;
	align?: "center" | "left";
};

const cols: Col[] = [
	{
		id: "name",
		Cell: Name,
		align: "left",
		label: "Nombre"
	},
	{
		id: "cif",
		Cell: Cif,
		label: "CIF",
		align: "center"
	},
	{
		id: "save",
		Cell: Save,
		label: "",
		align: "center"
	}
];

export default cols;
